module.exports = __webpack_public_path__ + "assets/add-ig-active.a8919d5f.svg";